// Badge cliccabile che mostra lo stato dei movimenti Iscrizione (Cau=1)
// di un alunno per l'anno filtrato.
// Verde: tutti pagati · Arancione: aperti · Rosso: scaduti · Grigio: nessun movimento.
// Feb 2026 — usato in Segremat Web Pro > Alunni (variante normale/compact) e >
// Curriculum (variante `boxStyle`, che replica la grafica dei bottoni CicloCheckboxes:
// quadrato 36×36, borderRadius 0, integrato nella stessa row).
export default function IscrizioneBadge({ counts, onClick, compact = false, boxStyle = false, testid = "iscr-badge" }) {
  const c = counts || null;
  const total = c?.total || 0;
  const paid = c?.paid || 0;
  const unpaid = c?.unpaid || 0;
  const scaduto = c?.scaduto || 0;
  const impTot = Number(c?.importo_totale || 0);
  const impPag = Number(c?.importo_pagato || 0);
  const impNonPag = Number(c?.importo_non_pagato || 0);

  // Stato colore (più vivi feb 2026)
  let bg = "#eceff1", fg = "#546e7a", brd = "#b0bec5", label = "—", icon = "";
  let title = "Nessun movimento Iscrizione (Cau=1) per questo anno";
  if (total > 0) {
    if (scaduto > 0) {
      bg = "#d32f2f"; fg = "#ffffff"; brd = "#b71c1c"; icon = "⚠"; label = fmtImporto(impNonPag);
      title = `${scaduto} movimenti SCADUTI (€ ${fmtImporto(impNonPag)} non pagato)`;
    } else if (unpaid > 0) {
      bg = "#f57c00"; fg = "#ffffff"; brd = "#e65100"; icon = "◷"; label = fmtImporto(impNonPag);
      title = `${unpaid}/${total} aperti · € ${fmtImporto(impNonPag)} da pagare`;
    } else {
      bg = "#2e7d32"; fg = "#ffffff"; brd = "#1b5e20"; icon = "✓"; label = fmtImporto(impPag);
      title = `Tutti pagati · ${paid}/${total} movimenti · € ${fmtImporto(impPag)}`;
    }
  }

  // 🆕 Variante "boxStyle": stessa grafica dei bottoni CicloCheckboxes (36×36, borderRadius 0)
  // Usato in Curriculum come primo elemento della row prima di I/P1/…/M3.
  // Colori (richiesta utente feb 2026):
  //   - nessun movimento          → fondo grigio + testo NERO
  //   - c'è movimento ma NON pagato → fondo BIANCO + testo nero (arancione se scaduto)
  //   - movimento PAGATO           → fondo verde + testo bianco
  if (boxStyle) {
    let bgSolid = "#cfd8dc", fgSolid = "#212121", brdSolid = "#90a4ae"; // default: nessuno
    if (total > 0) {
      if (paid > 0 && unpaid === 0 && scaduto === 0) {
        // Tutti pagati → verde
        bgSolid = "#2e7d32"; fgSolid = "white"; brdSolid = "#1b5e20";
      } else {
        // C'è movimento ma non tutto pagato → bianco + testo nero
        // Se scaduto, testo rosso per evidenziare urgenza
        bgSolid = "white";
        fgSolid = scaduto > 0 ? "#c62828" : "#212121";
        brdSolid = scaduto > 0 ? "#c62828" : "#90a4ae";
      }
    }
    return (
      <button onClick={onClick} disabled={total === 0}
        data-testid={testid} title={title}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 46, height: 36, padding: 0, flex: "0 0 auto",
          fontSize: 11, fontWeight: 900, letterSpacing: 0.3,
          border: `1px solid ${brdSolid}`,
          background: bgSolid, color: fgSolid,
          cursor: total > 0 ? "pointer" : "default",
          opacity: total > 0 ? 1 : 0.85,
          userSelect: "none", borderRadius: 0,
          boxShadow: total > 0 ? "0 1px 3px rgba(0,0,0,0.2)" : "none",
        }}>
        {total > 0 ? `${icon}€${label.split(",")[0]}` : "🎟"}
      </button>
    );
  }

  if (compact) {
    return (
      <button onClick={onClick} disabled={total === 0}
        data-testid={testid} title={title}
        style={{
          background: bg, color: fg, border: `2px solid ${brd}`,
          padding: "3px 10px", fontSize: 11, fontWeight: 900, fontFamily: "Consolas, monospace",
          borderRadius: 14, cursor: total > 0 ? "pointer" : "default",
          minWidth: 70, lineHeight: 1.4, letterSpacing: 0.2,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          boxShadow: total > 0 ? "0 1px 3px rgba(0,0,0,0.20)" : "none",
        }}>
        {total > 0 ? label : "—"}
      </button>
    );
  }
  return (
    <button onClick={onClick} disabled={total === 0}
      data-testid={testid} title={title}
      style={{
        background: bg, color: fg, border: `1px solid ${brd}`,
        padding: "3px 8px", fontSize: 11, fontWeight: 800, fontFamily: "Consolas, monospace",
        borderRadius: 12, cursor: total > 0 ? "pointer" : "default",
        display: "inline-flex", alignItems: "center", gap: 4, minWidth: 62, justifyContent: "center",
      }}>
      {total > 0 ? (
        <>
          <span>{icon}</span>
          <span>€ {label}</span>
        </>
      ) : (
        <span style={{ opacity: 0.55 }}>—</span>
      )}
    </button>
  );
}

function fmtImporto(v) {
  const n = Number(v) || 0;
  return n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
